import script from "./face-verify.vue?vue&type=script&lang=ts&setup=true"
export * from "./face-verify.vue?vue&type=script&lang=ts&setup=true"

import "./face-verify.vue?vue&type=style&index=0&id=d1a99c52&scoped=true&lang=less"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1a99c52"]])

export default __exports__